import { toQuery, type HttpClient } from '../client';
import type { LabelPrintResult, LabelQuery } from '../types/label';

const BASE = '/wl/label';

/** 标签打印：条码 / RFID EPC 标签，返回 ZPL 与可打印 HTML。 */
export function createLabelApi(http: HttpClient) {
  return {
    print(query: LabelQuery): Promise<LabelPrintResult> {
      return http.request<LabelPrintResult>({ path: `${BASE}/print`, query: toQuery(query) });
    }
  };
}

export type LabelApi = ReturnType<typeof createLabelApi>;
